import { toast } from 'vue-sonner'

const Make = (title: string, options: { [key: string]: any }) =>
  toast(title, options)
/**
 * The methods available via the Toasts object can be used to create
 * toasts in the SPA.
 *
 * Make is a generic function, while all others are helpers at
 * specified severity levels.
 */
const Toasts = {
  Make,
  Error: (
    title: string = 'Error',
    description: string | undefined = undefined,
    options: { [key: string]: any } = { closable: true },
  ) => toast.error(title, { ...options, description }),
  Info: (
    title: string,
    description: string | undefined = undefined,
    options: { [key: string]: any } = { closable: true },
  ) => toast.info(title, { ...options, description }),
  Success: (
    title: string = 'Success',
    description: string | undefined = undefined,
    options: { [key: string]: any } = { closable: true },
  ) => toast.success(title, { ...options, description }),
}

export default Toasts
